import { observer } from "mobx-react";
import React from "react";
import { OrbitComponent } from "../base-components/orbit-component/orbit-component";
import { BurnoutAnimationWrapper } from "./burnout-animation/burnout-animation-wrapper.component";

@observer
export class PlayerBurnoutLayerComponent extends OrbitComponent {
    render() {
        if (!this.services.burnoutService.renderAnimation) {
            return null;
        }
        return <BurnoutAnimationWrapper
            checkOmg={this.services.burnoutService.checkIfOmgDisplayed}
            showOmg={this.services.burnoutService.showOmg}
        />;
    }
}
